export const GET_ACCESS_MEDIUM = "GET_ACCESS_MEDIUM"
export const GET_ACCESS_MEDIUM_SUCCESS = "GET_ACCESS_MEDIUM_SUCCESS"
export const GET_MEDIUM_API_ERROR = "GET_MEDIUM_API_ERROR"


export const CREATE_MEDIUM_POST = "CREATE_MEDIUM_POST"
export const  CREATE_MEDIUM_POST_SUCCESS = "CREATE_MEDIUM_POST_SUCCESS"
export const CREATE_MEDIUM_POST_FAILD = "CREATE_MEDIUM_POST_FAILD"
